export default __webpack_public_path__ + "static/media/cc-view-tasks.728c43b9.jpg";